import OpenInNew from "@mui/icons-material/OpenInNew";
import { Box, Link, Stack, Typography } from "@mui/material";
import { SubmissionSource } from "generated-graphql/graphql";

export type RequirementCitationDisplay = {
  citation: string;
  url: string;
};

export function RequirementCitations({
  citations,
}: {
  citations: readonly RequirementCitationDisplay[];
}) {
  return (
    <Stack component="ul" spacing={1} sx={{ my: 0, pl: 2.5 }}>
      {citations.map((citation) => (
        <Typography component="li" variant="body2" key={`${citation.citation}-${citation.url}`}>
          <Link
            href={citation.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${citation.citation} (opens in a new tab)`}
          >
            {citation.citation}
            <OpenInNew sx={{ ml: 0.5, fontSize: "0.9em", verticalAlign: "text-bottom" }} />
          </Link>
        </Typography>
      ))}
    </Stack>
  );
}

export function SubmissionRequirementCitations({
  source,
  citations,
}: {
  source: SubmissionSource;
  citations: readonly RequirementCitationDisplay[];
}) {
  if (source !== SubmissionSource.System || citations.length === 0) {
    return null;
  }

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Why this is required
      </Typography>
      <RequirementCitations citations={citations} />
    </Box>
  );
}
